import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Grid } from "../core/components/grid.js";
import { Helper } from "../core/util/helper.js";
import React from "react";
import { Config } from "../core/config/config.js";

interface GridItem {
    BelegNr: number;
    RessNr: string;
    Article: string;
    ArticleNo: string;
    Lager: string;
    Lagerplatz: string;
    Resource: string;
    ExecutedOn: Date | string;
}

export default class OutgoingGoods extends React.Component<any, { data: GridItem[] }>{
    private gridOptions: kendo.ui.GridOptions;
    private ref: Grid;
    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
        this.initApp()
    }


    private initApp = async () => {
        this.gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            selectable: false,
            resizable: true,
            scrollable: true,
            filterable: false,
            editable: false,
            detailInit: this.detailInit,
            columns: [
                {
                    field: "BelegNr",
                    title: Helper.getTranslation("Field.Beleg.belegnr"),
                    template: ({ BelegNr }: GridItem) => {
                        return `<a href="${Config.baseUrl}ServiceReport/Edit?id=${BelegNr}" target="_blank">${BelegNr}</a>`
                    }
                },
                {
                    field: "Resource",
                    title: Helper.getTranslation("Ressource.Ressource"),
                }

            ]
        }
        const data = await HTTPService.get("ProjectLookup/OutgoingGoodsHistory?projNr=" + this.props.entity.Projnr);
        this.setState({data: data})
    }

    private detailInit = (e: kendo.ui.GridDetailInitEvent) => {
        const belegNr = e.data.get('BelegNr');
        const data = this.state.data.filter(f => f.BelegNr == belegNr);
        $("<div/>").appendTo(e.detailCell).kendoGrid({
            dataSource: {
                transport: {
                    read: (e) => {
                        e.success(data);
                    }
                },
            },
            scrollable: false,
            sortable: false,
            pageable: false,
            columns: [
                {
                    field: "Article",
                    title: Helper.getTranslation("Server.Settings.Article"),
                    template: (item: GridItem) => {
                        return `${item.Article} (${item.ArticleNo})`
                    }
                },
                {
                    field: "Lager",
                    title: Helper.getTranslation("WebSMS.Warehouse"),
                    template: (item: GridItem) => {
                        return `${item.Lager}/ ${item.Lagerplatz}`
                    }
                },
                {
                    field: "Amount",
                    title: Helper.getTranslation("Parts.ChargenSerien.Menge")
                },
                {
                    field: "ExecutedOn",
                    title: Helper.getTranslation("WebSMS.Warehouse.ExecutedOn"),
                    template: (item: GridItem) => {
                        return kendo.toString(kendo.parseDate(item.ExecutedOn.toString()), 'g')
                    }
                },
                {
                    field: "ExecutedBy",
                    title: Helper.getTranslation("WebSMS.Warehouse.ExecutedBy")
                }
            ]
        });
    }

    componentDidMount() {
        //Ich hasse unseren source -.-
        setTimeout(() => {
            this.ref?.getGridRef().expandRow(".k-master-row:first");
        }, 250)
    }

    render() {
        const data = this.state.data.map(item => { return { BelegNr: item.BelegNr, RessNr: item.RessNr, Resource: item.Resource } }).filter((value, index, array) => {
            return array.findIndex(f => f.BelegNr == value.BelegNr) === index;
        })
        return (
            <div className="flex-container">
                <Grid
                    data={data}
                    options={this.gridOptions}
                    id={`project_outgoing_goods`}
                    ref={(ref) => { this.ref = ref }}
                />
            </div>
        );
    }
}